import React from 'react';

import { messageUtility } from '../../utilities/messageUtility';
import { Confirmation } from './common';

export const ConfirmDeleteMachineryDialog = ({ dialog: { callback } }) => {
  return (
    <Confirmation
      visible={true}
      multilineText={true}
      title={messageUtility.getMessage('I-001-446')}
      message={messageUtility.getMessage('W-000-016', '機材')}
      confirmButtonText={messageUtility.getMessage('I-000-018')}
      cancelButtonText={messageUtility.getMessage('I-000-008')}
      onConfirm={callback.onConfirm}
      onCancel={callback.onCancel}
      isNegative={true}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/MachineryDialog.jsx